import * as React from 'react';
/**
 * A hook to combine multiple refs into a single ref. Useful for supporting a user-provided ref
 * while also maintaining an "internal ref" used by the component itself
 * @param refs ref[] to combine into one ref
 * @returns combined ref to use
 */
export function useCombineRefs(refs) {
    return React.useCallback(function (el) {
        refs.forEach(function (ref) {
            if (typeof ref === 'function') {
                ref(el);
            }
            else if (typeof ref === 'object' && ref !== null && 'current' in ref) {
                // eslint-disable-next-line no-param-reassign
                // @ts-ignore
                ref.current = el;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
useCombineRefs.displayName = 'useCombineRefs';
